/**
 * Drag previews render on `document.body`, outside `.s25-ng .dash`. Clone only the panel
 * header (`.d-head`) and wrap it in the Backbase hierarchy so dash header styles still apply.
 */
import { jSith } from "../../../../util/jquery-replacement";

/** Matches legacy id `sortbleHelperCloneHolder` (typo preserved for existing selectors/CSS). */
const DASH_SORTABLE_CLONE_HOLDER_ID = "sortbleHelperCloneHolder";

const DASH_SORTABLE_HEADER_PREVIEW_SHELL = `<div class="layout" style="height:auto !important; min-height:0 !important">
    <div class="s25-ng">
        <div class="dash">
            <div id="My25Live_table">
                <div class="isToolboxIdHolder">
                    <div id="${DASH_SORTABLE_CLONE_HOLDER_ID}" class="section"></div>
                </div>
            </div>
        </div>
    </div>
</div>`;

function buildHeaderPreviewShell(headerMarkup: string, isToolbox: boolean): HTMLElement {
    const parsedRoot = jSith.parseHTML(DASH_SORTABLE_HEADER_PREVIEW_SHELL.trim());
    if (!(parsedRoot instanceof HTMLElement)) {
        throw new Error("DashSortable: failed to parse header preview shell");
    }
    const cloneHolder = jSith.findSingle(parsedRoot, `#${DASH_SORTABLE_CLONE_HOLDER_ID}`);
    const isToolboxIdHolder = jSith.findSingle(parsedRoot, ".isToolboxIdHolder");
    if (!(cloneHolder instanceof HTMLElement) || !(isToolboxIdHolder instanceof HTMLElement)) {
        throw new Error("DashSortable: header preview shell missing holder nodes");
    }

    cloneHolder.innerHTML = headerMarkup;
    if (isToolbox) {
        isToolboxIdHolder.id = "toolbox";
    } else {
        isToolboxIdHolder.removeAttribute("id");
    }

    return parsedRoot;
}

/** Replaces the drag preview with a styled clone of the panel header row only. */
export function setDashPanelHeaderDragPreview(
    previewElement: HTMLElement,
    dragRootElement: HTMLElement,
    isToolbox: boolean,
): void {
    const previewSource =
        dragRootElement.querySelector(".d-head") ??
        dragRootElement.querySelector(".db-col-img-ornament-reservation-wizard")?.closest(".tb-row") ??
        dragRootElement.querySelector(".reserve-event-dash-layout");
    if (!(previewSource instanceof HTMLElement)) {
        return;
    }

    const previewClone = previewSource.cloneNode(true);
    if (!(previewClone instanceof HTMLElement)) {
        return;
    }
    previewElement.replaceChildren(buildHeaderPreviewShell(previewClone.outerHTML, isToolbox));
}
